<template>
  <div>
    <h4>Chat unblock</h4>

    <template v-if="chatUnblock !== null">
      <table
        class="props-compact mb-3"
      >
        <tr>
          <th>Id</th>
          <td>{{chatUnblock.id}}</td>
        </tr>
        <tr>
          <th>Unblocker</th>
          <td>
            <user-link
              :user="chatUnblock.user"
            />
          </td>
        </tr>
        <tr>
          <th>Time</th>
          <td>{{chatUnblock.ctime | getMomentMinStr}}</td>
        </tr>
      </table>

      <p class="prop-lable">Reason</p>
      <p>
        {{chatUnblock.reason}}
      </p>
    </template>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import UserLink from './UserLink.vue';

export default {
  name: 'PlayerChatUnblock',

  components: {
    LoadingIndicator,
    UserLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    chatUnblockId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      chatUnblock: null,
    };
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.isLoading = true;

    const url = `/player/${this.playerId}/chat_unblock/${this.chatUnblockId}`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.');
        return;
      }

      this.chatUnblock = data;
    })
    .catch(e => {
      this.isLoading = false;
      notifier.showError(e.response.data, {sender: this});
    });
  },
};
</script>
